<template>
  <div>
    <div class="u-dialog-tips">
      <p>每次查询前，均需要登录网站获取最新的Cookie。请根据<a @click="toGuidePage">违章查询操作指南</a>进行获取和填写。</p>
    </div>
    <el-form ref="cookieRef" :model="uDunForm" :rules="uDunRule" label-width="80px">
      <el-form-item label="Cookie"  prop="cookie">
        <el-input
          v-model="uDunForm.cookie"
          type="textarea"
          rows="4"
          clearable/>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { openNewPages } from '@/utils'
import { queryViolationAccount } from '@/api/domain/carsService'
import { isEmojiCharacter } from '@/utils/validate'

export default {
  props: {
    content: {
      type: Object,
      default: () => ({}),
    },
    isSave: {
      type: Boolean,
      default: false,
    },
    dialogVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      uDunForm: {
        cookie: '',
      },
      uDunRule: {
        cookie: [{ required: true, validator: this.validateCookie, trigger: 'blur' }],
      },
    }
  },
  watch: {
    isSave: {
      handler(val) {
        if (val) {
          this.queryAccount()
        }
      },
    },
    dialogVisible: {
      handler(val) {
        this.uDunForm.cookie = ''
        if (val) {
          this.$nextTick(() => {
            this.$refs.cookieRef.clearValidate()
          })
        }
      },
      immediate: true,
    },
  },
  methods: {
    validateCookie(rule, value, callback) {
      if (!value || !value.trim()) {
        callback(new Error('请填写Cookie'))
      }
      if (isEmojiCharacter(value)) {
        callback(new Error('禁止输入表情'))
      }
      callback()
    },
    toGuidePage() {
      const params = {
        path: '/vehicle/violation/guide',
      }
      openNewPages(params)
    },
    queryAccount() {
      this.$refs.cookieRef.validate((valid) => {
        if (!valid) {
          this.$emit('saveResult', true)
          return
        }
        queryViolationAccount({
          account: this.content.account,
          id: this.content.id,
          cookie: this.uDunForm.cookie,
        }).then(({ code }) => {
          if (code === 1) {
            this.$emit('saveResult', false)
          } else {
            this.$emit('saveResult', true)
          }
        }).catch(() => {
          this.$emit('saveResult', true)
        })
      })
    },
  },
}
</script>
<style lang="less" scoped>
.u-dialog-tips {
  background: #ECF3FF;
  border-radius: 5px;
  padding: 10px;
  margin-bottom: 20px;
}
</style>
